/**
 * Determine if there is an error in the state
 *
 * @param  {Object} state
 * @return {Boolean}
 */
const hasError = state => Object.keys(state.upload.error).length > 0

/**
 * Determine if there is analysis data available
 *
 * @param  {Object} state
 * @return {Boolean}
 */
const hasAnalysisData = state => Object.keys(state.analysis.data).length > 0

/**
 * Return a normalized version of the filter key to use for narrowing down a list
 *
 * @param  {Object} state
 * @return {String}
 */
const normalizedFilterKey = state => state.analysis.filterTerm
    ? state.analysis.filterTerm.toLowerCase()
    : ''

/**
 * Get a filtered list of sidebar items
 *
 * @param  {Object} state
 * @param  {Object} getters
 * @return {Array}
 */
const sidebarListItems = (state, getters) => ['miscinc', 'opex'].reduce((topResult, key) => {
    topResult[key] = state.analysis.data[key].line_items.map(i => {
        let obj = i
        obj.show = i.name.toLowerCase().includes(getters.normalizedFilterKey)
        obj.type = key
        return obj
    })
    .reduce((result, i) => {
        if (!result[i.category]) {
            result[i.category] = { items: [] }
        }
        result[i.category].items.push(i)
        return result
    }, {})
    return topResult
}, { miscinc: {}, opex: {} })

/**
 * Determine if there is a selected item in state
 *
 * @param  {Object} state
 * @return {Boolean}
 */
const hasSelectedItem = state => Object.keys(state.analysis.selectedItem).length > 0

/**
 * Total pages of data in the provided dataset
 *
 * @param  {Object} state
 * @return {Number}
 */
const totalPages = state => {
    let rows = state.data.rentroll.data.table_data.meta.number_of_rows + 1
    let limit = state.data.rentroll.pagination.pageLimit

    return Math.ceil(rows / limit)
}

/**
 * Get the offset for the dataset
 *
 * @return {Number}
 */
const offset = state => (state.data.rentroll.pagination.currentPage - 1) * state.data.rentroll.pagination.pageLimit

/**
 * Paginated Dataset
 *
 * @param  {Object} state
 * @param  {Object} getters
 * @return {Array}
 */
const paginatedDataset = (state, getters) => {
    return state.data.rentroll.data.table_data.data.map(row => {
        return {
            format: row.format,
            is_calculated_total: row.is_calculated_total,
            our_label: row.our_label,
            their_label: row.their_label,
            data: row.data.slice(getters.offset, (state.data.rentroll.pagination.pageLimit * state.data.rentroll.pagination.currentPage))
        }
    })
}

export default {
    offset,
    hasError,
    totalPages,
    hasSelectedItem,
    hasAnalysisData,
    paginatedDataset,
    sidebarListItems,
    normalizedFilterKey
}



// WEBPACK FOOTER //
// ./src/state/modules/importer/getters.js